import { Flow, FlowInformation, FlowName } from '../../../@types/flow-types'
import { CONFIGURE_OBJECT_CHOOSER } from '../../actions/flowInformation/flowInformation.types'
import { FlowState } from '../../../@types/state-types'
import { ContentStateInterface, FlowMetaData, ObjectParams } from '../../../@types/types'
import { DisplayObjectChooserType } from '../../../@types/object-chooser-types'
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { findObjects } from '../../../api/object/objectApi'
import { ConvertedRealEstate } from '../../../@types/real-estate-api-types'

export const initialState: FlowState = {
  flowInformation: {
    name: '' as FlowName,
    estateType: '',
    offerType: '',
    owner: '',
    path: '',
    validationSchema: {},
    options: undefined,
    metaData: {} as FlowMetaData,
  },
  objectChooserInformation: {
    objects: undefined,
    displayObjectChooser: DisplayObjectChooserType.UNKNOWN,
    insertionFlowDataLoaded: false,
    objectChooserBackButton: false,
    objectSelected: false,
    objectChooserShown: false,
  },
}

const slice = createSlice({
  name: 'flowFeature',
  initialState,
  reducers: {
    updateFlowInformation(state, action: PayloadAction<FlowInformation>) {
      state.flowInformation = action.payload
    },
    hideObjectChooser: (state) => {
      state.objectChooserInformation.displayObjectChooser = DisplayObjectChooserType.NO
    },
    updateFlow(state, action: PayloadAction<Flow>) {
      state.flow = action.payload
    },
    objectChooserWasShown(state) {
      state.objectChooserInformation.objectChooserShown = true
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getObjectThunk.fulfilled, (state, action) => {
        const objectsFromApi = action.payload.response

        const shouldDisplayObjectChooser =
          objectsFromApi && objectsFromApi.length ? DisplayObjectChooserType.YES : DisplayObjectChooserType.NO

        state.objectChooserInformation.displayObjectChooser = shouldDisplayObjectChooser

        state.objectChooserInformation.objects = objectsFromApi

        if (shouldDisplayObjectChooser === DisplayObjectChooserType.YES) {
          state.objectChooserInformation.objectChooserBackButton = true
        }
        state.objectChooserInformation.objectChooserShown =
          state.objectChooserInformation.objectChooserShown ||
          [DisplayObjectChooserType.YES].includes(state.objectChooserInformation.displayObjectChooser)
      })
      .addCase(getObjectThunk.pending, (state) => {
        state.objectChooserInformation.displayObjectChooser = DisplayObjectChooserType.LOADING
      })
      .addCase(getObjectThunk.rejected, (state) => {
        state.objectChooserInformation.displayObjectChooser = DisplayObjectChooserType.NO
      })
      .addMatcher(
        (action) => action.type === CONFIGURE_OBJECT_CHOOSER,
        (state, action: PayloadAction<Payload>) => {
          state.objectChooserInformation.displayObjectChooser = action.payload.displayObjectChooser
          state.objectChooserInformation.objects = action.payload.objects
          state.objectChooserInformation.objectSelected = !!action.payload.objectSelected
          state.objectChooserInformation.insertionFlowDataLoaded = !!action.payload.insertionFlowDataLoaded
          if (action.payload.displayObjectChooser === DisplayObjectChooserType.YES) {
            state.objectChooserInformation.objectChooserBackButton = true
          }
          state.objectChooserInformation.objectChooserShown =
            state.objectChooserInformation.objectChooserShown ||
            action.payload.displayObjectChooser === DisplayObjectChooserType.YES
        }
      )
  },
})
export const { updateFlowInformation, hideObjectChooser, updateFlow, objectChooserWasShown } = slice.actions
export default slice.reducer
export const getObjectThunk = createAsyncThunk('flowFeature/getObject', async (payload: FindObjectParams) => {
  const response = await findObjects(payload.defaultStateValues, payload.objectParams)
  return { response }
})

type Payload = {
  displayObjectChooser: DisplayObjectChooserType
  objects?: ConvertedRealEstate[]
  insertionFlowDataLoaded?: boolean
  objectSelected?: boolean
}

type FindObjectParams = {
  defaultStateValues: ContentStateInterface
  objectParams: ObjectParams
}
